import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Surgery = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="surgery icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.6309 0.825747C21.8079 0.115239 20.5681 0.192341 19.8395 0.999337L1.01395 21.85C0.491078 22.4291 0.807538 23.3197 1.58633 23.3671C4.09379 23.5196 8.70782 23.3198 11.6428 20.2987C14.1064 17.7628 14.1958 14.0952 14.1958 14.0952L23.0547 3.83388C23.7766 2.99779 23.6839 1.73485 22.8478 1.01303L22.6309 0.825747ZM23 21.5H13.1668C12.7501 22 11.6668 23 10.1668 23.5H23C23.5523 23.5 24 23.0523 24 22.5C24 21.9477 23.5523 21.5 23 21.5Z"
    />
  </svg>
)
